import styled from 'styled-components';

export const StyledSelectedTable = styled.div`
  margin-bottom: 24px;
  border-top: 1px solid #dadada;

  .MuiTableHead-root {
    background-color: #f8f8f8;
  }

  .MuiTableCell-root {
    padding: 9px 14px;
    border-bottom: 1px solid #dadada;
  }
`;
